import { Box, Tooltip } from '@mantine/core';
import classes from './ScanTag.module.css';

export interface ScanTagProps {
  name: string;
  description: string;
  withTooltip?: boolean;
}

export const ScanTag = ({ withTooltip = false, ...props }: ScanTagProps) => {
  const scanTag = (
    <Box
      data-testid="scan-tag"
      className={classes.scanTag}
      px="xs"
      c="grayBrand.8"
      fw={500}
      fz="sm"
      ta="center"
    >
      {props.name}
    </Box>
  );
  if (!withTooltip) return scanTag;

  return (
    <Tooltip
      multiline
      label={props.description}
      withArrow
      classNames={{ tooltip: classes.tooltip }}
    >
      {scanTag}
    </Tooltip>
  );
};
